// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout-module--wrapper--1_nDp","content":"Layout-module--content--nwbxQ"};